export const STUFF_TILE_ID = "StuffTileId";
export const STUFF_TILE_TITLE_ID = "StuffTileTitleId";
export const STUFF_TILE_TITLE_HOVERED_ID = "StuffTileTitleHoveredId";
export const STUFF_TILE_ICON_ID = "StuffTileIconId";
export const STUFF_TILE_TOOLTIP_ID = "StuffTileTooltipId";
export const STUFF_TILE_DESCRIPTION_ID = "StuffTileDescriptionId";
export const STUFF_TILE_LINK_ID = "StuffTileLinkId";
export const STUFF_TILE_LOCKED_NOTE_ID = "StuffTileLockedNoteId";
export const STUFF_TILE_LOCK_ID = "StuffTileLockId";
